import confirmPaymentIntent from './confirmPaymentIntent';
import createPaymentCommand from './createPaymentCommand';
import createPaymentIntent from './createPaymentIntent';
import getClaimGroupLastPaymentQuery from './getClaimGroupLastPaymentQuery';
import getFileLastPaymentQuery from './getFileLastPaymentQuery';
import getFilePaymentsQuery from './getFilePaymentsQuery';
import getOpenedInvoiceByFileQuery from './getOpenedInvoiceByFileQuery';
import getOpenedInvoiceQuery from './getOpenedInvoiceQuery';
import { getPaymentAccountForContextQuery } from './getPaymentAccountForContextQuery';
import { getPaymentSessionQuery } from './getPaymentSessionQuery';
import issuePaymentCommand from './issuePaymentCommand';

export const PaymentService = {
  confirmPaymentIntent,
  createPaymentIntent,
  getFilePaymentsQuery,
  issuePaymentCommand,
  getClaimGroupLastPaymentQuery,
  getOpenedInvoiceQuery,
  getOpenedInvoiceByFileQuery,
  createPaymentCommand,
  getFileLastPaymentQuery,

  getPaymentAccountForContextQuery,
  getPaymentSessionQuery,
};
